import { Component, HostBinding, Input } from '@angular/core';

/**
 * The Codigrate loader (2026-10-12): the two halves of the logo clapping, the dots between them, the one the
 * home page's download counter shows while it loads (its styles are global: styles/loading/loading.scss).
 * `scale` grows it for a picture's overlay (with zoom, so it is drawn at that size).
 */
@Component( {
  selector: 'app-codigrate-loader',
  template: `
    <span class="counter-loader-container">
      <span class="counter-loader-left"></span>
      <span class="counter-loader-right"></span>
      <span class="counter-loader-dots"><span class="dot"></span><span class="dot"></span><span class="dot"></span></span>
      <span class="counter-loader-warp-left"></span>
      <span class="counter-loader-warp-right"></span>
    </span>`,
  styles: [ `
    :host {
      position: relative;
      display: inline-block;
      width: 1.654rem;
      height: 1.3rem;
      /* zoom, not transform: the loader is laid out and drawn at its size, so it stays sharp (a scaled
         transform blew up its small raster and came out soft) */
      zoom: var(--loader-scale, 1);
    }
    .counter-loader-container { top: 0; }
  ` ],
} )
export class CodigrateLoaderComponent {
  @Input() set scale( value: number ) {
    this.scaleVar = String( value || 1 );
  }

  @HostBinding( 'style.--loader-scale' ) scaleVar = '1';

  @HostBinding( 'attr.role' ) role = 'status';
  @HostBinding( 'attr.aria-label' ) @Input() label = 'Loading';
}
